import { render, staticRenderFns } from "./ModalWorkHistory.vue?vue&type=template&id=3c745f58&"
import script from "./ModalWorkHistory.vue?vue&type=script&lang=js&"
export * from "./ModalWorkHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports